/* eslint-disable no-console */
import Cookies from 'js-cookie';
import { ENABLED_FEATURES, FEATURES } from 'src/common/hooks/useFeatureFlag';

const OPTIONAL_FEATURES = FEATURES.filter(feature => !ENABLED_FEATURES.includes(feature));

function getCookie() {
  return Cookies.get('gmb_features')?.split(',') ?? [];
}

function showSelector() {
  const active = getCookie();
  const defined = Array.from(new Set([...OPTIONAL_FEATURES, ...active])).sort();
  const enabled = Array.from(new Set([...ENABLED_FEATURES, ...active])).sort();
  const padding = Math.max(...[...enabled, ...defined].map(flag => flag.length));
  const headingStyle = 'font-weight: 600';
  const activeStyle = 'color: #000; background-color: #6DF0F7';
  const inactiveStyle = 'color: #444; background-color: #ccc';

  console.group('Features');

  if (ENABLED_FEATURES.length) {
    console.log('%cEnabled for all users', headingStyle);
    enabled.forEach((flag) => {
      console.log(`${flag.padEnd(padding)} %c enabled for all users `, activeStyle, '⚠️');
    });
    console.log('');
    console.log('%cOptional', headingStyle);
  }

  defined.forEach((flag) => {
    const isActive = active.includes(flag);
    console.log(`${flag.padEnd(padding)} %c ${isActive ? 'enabled' : '--'} `, isActive ? activeStyle : inactiveStyle);
  });
  console.groupEnd();
}

function isValid(flag: string) {
  const yes = (OPTIONAL_FEATURES as unknown as string[]).includes(flag);
  if (!yes) {
    console.warn(`Unknown flag: ${flag}`);
  }
  return yes;
}

function validateFlags(flags: string[]) {
  return Array.from(new Set(flags))
    .filter(isValid)
    .sort()
    .join(',');
}

function add(...flags: string[]) {
  const active = getCookie();
  const list = validateFlags(flags.length
    ? [...active, ...flags]
    : [...OPTIONAL_FEATURES]);

  if (list.length) {
    Cookies.set(
      'gmb_features',
      list,
    );
  }
  showSelector();
}

function remove(...flags: string[]) {
  const active = getCookie();
  const list = validateFlags(active.filter(flag => !flags.includes(flag)));

  // remove all
  if (!list.length || !flags.length) {
    Cookies.remove('gmb_features');
  } else {
    Cookies.set(
      'gmb_features',
      list,
    );
  }
  showSelector();
}

if (typeof window !== 'undefined') {
  window.gmb = window.gmb || {};
  window.gmb.featureFlags = {
    showSelector,
    add,
    remove,
  };
}

declare global {
  interface Window {
    gmb: GMB;
  }
  interface GMB {
    featureFlags: {
      showSelector: () => void;
      add: (...flags: string[]) => void;
      remove: (...flags: string[]) => void;
    };
  }
}
